import { v4 as uuid } from 'uuid';

export class Emp {

  static END_POINT = "emp";

  serno = 0;
  guid;//= uuid();

  emp_id = "";
  emp_pw = "";
  emp_name = "";
  title = "";

  constructor() {
    this.guid = uuid();
  }


}